module.exports = __webpack_public_path__ + "img/meta-vorschau.2f344207.jpg";